export default __webpack_public_path__ + "static/media/IMG_5533.fcc183b8.jpg";